// Anclas del Backyard accessory: clipboard + house keys.
// Silhouette = small clipboard with a checked list + key ring with 2 keys.
// The check marks + keys together say "the person who runs the place."
// Domestic warmth — the tía who has the schedule AND the keys.

interface ClipboardKeysProps {
  /** Primary fill (clipboard board). Defaults to backyard string-light green. */
  bodyColor?: string;
  /** Accent fill (keys + clip). Defaults to marker beige. */
  accentColor?: string;
  /** Rendered size in px (square bounding box). */
  size?: number;
  /** Optional className for positioning. */
  className?: string;
}

export function ClipboardKeys({
  bodyColor = '#5fd17e',
  accentColor = '#c8b89a',
  size = 48,
  className,
}: ClipboardKeysProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      {/* Clipboard board — slight perspective tilt */}
      <rect x="6" y="8" width="22" height="30" rx="1" fill={bodyColor} />
      {/* Board edge shadow */}
      <rect x="6" y="36" width="22" height="2" fill="rgba(0,0,0,0.25)" />
      {/* Clip at top */}
      <rect x="12" y="5" width="10" height="6" rx="1" fill={accentColor} />
      <rect x="14" y="6" width="6" height="3" fill="rgba(0,0,0,0.3)" />
      {/* Paper lines — 3 list items */}
      <line x1="10" y1="16" x2="24" y2="16" stroke="rgba(0,0,0,0.35)" strokeWidth="1" />
      <line x1="10" y1="22" x2="24" y2="22" stroke="rgba(0,0,0,0.35)" strokeWidth="1" />
      <line x1="10" y1="28" x2="24" y2="28" stroke="rgba(0,0,0,0.35)" strokeWidth="1" />
      {/* Checkbox checkmarks — first two items checked */}
      <path d="M9 15 L10 17 L12 14" stroke="rgba(0,0,0,0.6)" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      <path d="M9 21 L10 23 L12 20" stroke="rgba(0,0,0,0.6)" strokeWidth="1.2" fill="none" strokeLinecap="round" />
      {/* Key ring — overlapping clipboard's right edge */}
      <circle cx="34" cy="22" r="4" fill="none" stroke={accentColor} strokeWidth="2" />
      {/* Key 1 — pointing down-right */}
      <g transform="rotate(35 36 24)">
        <rect x="35" y="24" width="2" height="10" fill={accentColor} />
        <rect x="33" y="22" width="6" height="4" rx="1" fill={accentColor} />
        <circle cx="34" cy="24" r="1.5" fill={bodyColor} />
        {/* Teeth */}
        <rect x="37" y="30" width="1.5" height="2" fill={accentColor} />
        <rect x="37" y="33" width="2" height="2" fill={accentColor} />
      </g>
      {/* Key 2 — pointing down-left */}
      <g transform="rotate(-25 32 24)">
        <rect x="31" y="24" width="2" height="9" fill={accentColor} />
        <rect x="29" y="22" width="6" height="4" rx="1" fill={accentColor} />
        <circle cx="32" cy="24" r="1.5" fill={bodyColor} />
        <rect x="29" y="29" width="1.5" height="2" fill={accentColor} />
      </g>
    </svg>
  );
}
